
<div class="d-flex justify-content-between align-items-center px-3">

  <div>
    <p class="date-info-result-flight-hour">{{getDateInfo('departureInitial') | date: 'HH:mm'}}</p>
    <p class="date-info-result-flight-city">{{getDateInfo('departureCity')}}</p>
    <p class="date-info-result-flight-iata">{{getDateInfo('departureAirportIata')}}</p>
  </div>
  <div>
    <p class="date-info-result-flight-duration">{{getDateInfo('durationFlight')}}</p>
    <p class="date-info-result-flight-segment">{{getDateInfo('segmentQty')}}</p>
    <p class="date-info-result-flight-class">{{ getDateInfo('class') }}</p>
  </div>
  <div class="d-flex flex-column align-items-end">
    <p class="date-info-result-flight-hour">{{getDateInfo('arrivalDestination') | date: 'HH:mm'}}</p>
    <p class="date-info-result-flight-city">{{getDateInfo('arrivalDestinationCity')}}</p>
    <p class="date-info-result-flight-iata">{{getDateInfo('arrivalDestinationAirportIata')}}</p>
  </div>



</div>

<div>
  <!-- <p class="mt-2" style="font-size: 12px; color: #666;" (click)="openModalDetail(result);" style="cursor: pointer;">
    Ver detalles del vuelo <i class="bi bi-chevron-right" style="font-size: 10px;"></i>
  </p> -->
</div>
